import { useTrackEvent } from "kanopi-components/tracking";

import { useUser } from "../../auth/useUser";

export function useTrackPolicyViewed({ ...args } = {}) {
  const user = useUser();
  const _trackPolicyViewed = useTrackEvent({
    event: "Policy Viewed",
    now: false,
    ...args,
  });
  return function trackPolicyViewed({
    policy,
    riskProfile,
    ...other
  }: {
    policy: TPolicy;
    riskProfile: TRiskProfile;
  }) {
    _trackPolicyViewed({
      properties: {
        enabledProducts: policy?.quote?.product,
        enabledCovers: policy?.quote?.covers?.map(({ title }) => title),
        riskProfileId: riskProfile.id,
        currency: "AUD",
        distributionPartner: user?.latestReferrer?.key,
        pretaxPremium: policy?.quote?.preTaxPremium,
        commission: policy?.quote?.commission,
        total: riskProfile?.periodicPrice,
        ...other,
      },
    });
  };
}

export function useTrackClaimStarted({ ...args } = {}) {
  const user = useUser();
  const _trackClaimStarted = useTrackEvent({
    event: "Claim Started",
    now: false,
    ...args,
  });
  return function trackClaimStarted({
    riskProfile,
    policy,
    ...other
  }: {
    riskProfile: TRiskProfile;
    policy: TPolicy;
  }) {
    _trackClaimStarted({
      properties: {
        riskProfileId: riskProfile?.id,
        distributionPartner: user?.latestReferrer,
        currency: "AUD",
        covers: policy?.quote?.covers.map((cover: TCoverSection) => cover.title),
        pretaxPremium: policy?.quote?.preTaxPremium,
        commission: policy?.quote?.commission,
        total: riskProfile?.periodicPrice,
        ...other,
      },
    });
  };
}
